import React from 'react'
import Helmet from 'react-helmet'
import { members } from './members'
import TeamMember from '../generic/ProfileSummary'
import './styles.css'

function Team() {
  return (
    <div id="Team">
      <Helmet>
        <title>The Team | Stan Winston School of Character Arts</title>
        <meta name="description" content="Find the best team in the field of Special Effects Character Creation, Character Design & Makeup FX" />
        <meta property="og:title" content="The Team | Stan Winston School of Character Arts" />
        <meta property="og:description" content="Find the best team in the field of Special Effects Character Creation, Character Design & Makeup FX" />
      </Helmet>
      <div className="banner" />
      <div className="team-groups wrapper">
        <h1>It&apos;s all about collaboration</h1>
        {members.map((group, groupIndex) => (
          <div key={groupIndex} className="group">
            <h2>{group.groupName}</h2>
            <div className="group-members">
              {group.groupMembers.map((member, memberIndex) => (
                <TeamMember
                  key={`member-${memberIndex}`}
                  className="member"
                  name={member.name}
                  photo={member.portraitImage}
                  slug={member.slug}
                  tagline={member.position}
                  variant="teamMember"
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Team
